import { lazy, Suspense } from 'react'

import { Loading } from '@/components/Loading'
import { ShipperSlider } from '@/components/ShipperSlider'

const MessagesPanel = lazy(() => import('./MessagesPanel'))
type Props = {
  open?: boolean
  onClose?: () => void
}
export const MessagesApp = ({ open, onClose }: Props) => {
  return (
    <ShipperSlider
      flush
      className="flex flex-col flex-nowrap items-stretch"
      onClose={onClose}
      isOpen={open}
      width="72rem"
    >
      <Suspense fallback={<Loading />}>
        <MessagesPanel onClose={onClose} />
      </Suspense>
    </ShipperSlider>
  )
}
